import React, { forwardRef, useImperativeHandle, useState } from 'react'
import Modal from 'components/molecules/Dialog'
import atendimento from '../../../../assets/images/atendimento_sac.png'
import { Button } from '@material-ui/core'
import { useHeaderStorage } from '../../../../components/Header/storage'
import { useSelector } from 'react-redux'
import { useAtendimentoSacStorage } from '../../../../components/Header/AtendimentoSac/storage'
import { searchColorSistem } from '../../../../components/Header/AtendimentoSac/hook/request'

function ModalIncidenteOptions({ ...props }, ref) {

    const { setGrupoIncidente } = useAtendimentoSacStorage(state => state.dispatch)

    const authState = useSelector((state) => state.auth);

    const [open, setOpen] = useState(false)

    useImperativeHandle(
        ref,
        () => ({
            open() {
                setOpen(true)
            }
        })
    )

    const openModalAtendimento = (grupo) => {
        setGrupoIncidente(grupo)
        searchColorSistem()
        setOpenAtendimentoSac(true)
    }

    const { setOpenAtendimentoSac} = useHeaderStorage(state => state.dispatch)

    return (
        <Modal fullWidth={true} open={open} onClose={() => { setOpen(false) }}>
            <div style={{ height: '400px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                <img src={atendimento} width={300} style={{ alignSelf: 'center' }} />
                <h2 style={{ textAlign: 'center', color: 'black',  }}>
                    Bem vindo ao abertura de incidentes! {/* a <b style={{color: 'red'}}>Sefaz Autorizadora está temporariamente indisponível.</b> */}
                </h2>

                <div style={{ display: 'flex', justifyContent: 'space-around'}}>

                    <Button
                        variant="contained"
                        type="submit"
                        onClick={()=>{openModalAtendimento('AZAPERS')}}
                    /* className={`${classes.button} align-self-center justify-content-center align-items-center`} */
                    >
                        solicitar suporte Azapfy
                    </Button>
                    <Button
                        size="medium" color="primary"
                        variant="contained"
                        type="submit"
                        onClick={()=>{openModalAtendimento(authState.grupo_ativo)}}
                    /* className={`${classes.button} align-self-center justify-content-center align-items-center`} */
                    >
                        gerar novo incidente
                    </Button>
                </div>
               {/*  <h2 style={{ textAlign: 'center', color: 'black' }}>Para garantir o sucesso da emissão, sugerimos a alternativa de emissão SVC - Sefaz Virtual de contingência.</h2> */}
            </div>
        </Modal>
    )
}


export default forwardRef(ModalIncidenteOptions)